import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'nallian-shared-ui/lib/config/i18n';

const WithTranslations = ({ translations, children }) => {
  useEffect(() => {
    if (i18n?.options?.languages?.length && translations) {
      i18n.options.languages.forEach(language => {
        if (translations[language] && !i18n.hasResourceBundle(language, 'app')) {
          i18n.addResources(language, 'app', translations[language]);
        }
      });
    }
  }, [translations]);

  return <>{children}</>;
};

WithTranslations.propTypes = {
  i18n: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  translations: PropTypes.object.isRequired,
};

export default WithTranslations;
